export const LOAD_FOLDER_SUMMARY_SUCCEEDED = "LOAD_FOLDER_SUMMARY_SUCCEEDED";
export const LOAD_FOLDER_SUMMARY_FAILED = "LOAD_FOLDER_SUMMARY_FAILED";
